
    import './styles.scoped.css';
    export default {
  "button-trigger": "awsui_button-trigger_18eso_1mlop_17",
  "arrow": "awsui_arrow_18eso_1mlop_17",
  "in-filtering-token-root": "awsui_in-filtering-token-root_18eso_1mlop_77",
  "in-filtering-token-nested": "awsui_in-filtering-token-nested_18eso_1mlop_77",
  "has-caret": "awsui_has-caret_18eso_1mlop_113",
  "placeholder": "awsui_placeholder_18eso_1mlop_116",
  "pressed": "awsui_pressed_18eso_1mlop_132",
  "disabled": "awsui_disabled_18eso_1mlop_138",
  "in-filtering-token": "awsui_in-filtering-token_18eso_1mlop_77",
  "readonly": "awsui_readonly_18eso_1mlop_159",
  "invalid": "awsui_invalid_18eso_1mlop_182",
  "warning": "awsui_warning_18eso_1mlop_191",
  "custom-option": "awsui_custom-option_18eso_1mlop_200",
  "inline-tokens": "awsui_inline-tokens_18eso_1mlop_205",
  "grouped": "awsui_grouped_18eso_1mlop_208",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_18eso_1mlop_214",
  "grouped-in-validation": "awsui_grouped-in-validation_18eso_1mlop_221",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_18eso_1mlop_235",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_18eso_1mlop_255",
  "grouped-horizontal-only": "awsui_grouped-horizontal-only_18eso_1mlop_276",
  "grouped-vertical-first": "awsui_grouped-vertical-first_18eso_1mlop_298",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_18eso_1mlop_319",
  "grouped-vertical-last": "awsui_grouped-vertical-last_18eso_1mlop_339",
  "grouped-vertical-only": "awsui_grouped-vertical-only_18eso_1mlop_360",
  "grouped-with-action": "awsui_grouped-with-action_18eso_1mlop_382",
  "grouped-validation": "awsui_grouped-validation_18eso_1mlop_386"
};
  